/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { closeDialog } from '../../redux/features/dialogs/dialog.slice';
import { saveSubmissionAndRedirect, creatEpctRedirect } from '../../redux/features/dialogs/dialog.thunk';

export const GenericDialogActionsConfig = Object.freeze({
  close: closeDialog,
  saveSubmissionAndRedirect,
  creatEpctRedirect
});
